import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ShellIconComponent } from '../../../shared/shell-icon/shell-icon.component';

@Component({ selector:'app-admin-home', standalone:true, imports:[RouterLink, ShellIconComponent], templateUrl:'./admin-home.component.html', styleUrl:'./admin-home.component.scss' })
export class AdminHomeComponent {}
